import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import noopStorage from "@/store/storage/noopStorage";
import {createSelector} from "reselect";

interface IGlobalState {
    validations: object,
}

interface ISetValidationsPayload {
    errors: object,
    formName?: string,
}

interface IRemoveValidationsByNamePayload {
    name: string,
    formName?: string,
}

const initialState: IGlobalState = {
    validations: [],
};

export const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setValidations: (state, action: PayloadAction<ISetValidationsPayload>) => {
            if (action.payload.formName){
                state.validations = [
                    {
                        errors: action.payload.errors,
                        formName: action.payload.formName,
                    }
                ]
            }else {
                state.validations = action.payload.errors
            }

        },
        removeValidations: (state) => {
            state.validations = [];
        },
        removeValidationsByName: (state, action: PayloadAction<IRemoveValidationsByNamePayload>) => {
            state.validations = removeValidateByName(action.payload.name, state.validations, action.payload.formName)
        },
    },
});

const removeValidateByName = (name: string, validations: object | Array<any>, formName: string | undefined) =>{
    if (formName && Array.isArray(validations)){
        // @ts-ignore
        return validations.map((error)=>{
            if (error.formName === formName){
                const val = {}

                for (let er in error.errors){
                    if (er !== name){
                        // @ts-ignore
                        val[er] = error.errors[er]
                    }
                }

                return {
                    ...error,
                    errors: val
                }
            }

            return error
        })
    }else {
        const val = {}

        for (let er in validations){
            if (er !== name){
                // @ts-ignore
                val[er] = validations[er]
            }
        }

        return val
    }
}

// Action creators are generated for each case reducer function
export const {
    setValidations,
    removeValidations,
    removeValidationsByName,
} = globalSlice.actions;

const globalReducer = globalSlice.reducer;

const globalPersistConfig = {
    key: 'global',
    storage: noopStorage,
    whitelist: [''],
};

export const selectGlobalSelector = createSelector(
    (state) => state.global,
    (global) => global
)

export const globalPersistReducer = persistReducer(globalPersistConfig, globalReducer)